import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import {
  faInstagram,
  faFacebookF,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import ReactModal from 'react-modal';
import './MenuMobile.scss';
import contactInfo from '../contact-info.json';

export const MenuMobile = ({
  isOpen,
  onClose,
  scrollToSection,
}: MenuMobileProps) => {
  const handleLinkClick = (sectionId: string) => {
    onClose();
    scrollToSection(sectionId);
  };
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal-content"
    >
      <div className="close">
        <FontAwesomeIcon icon={faXmark} className="icon" onClick={onClose} />
      </div>
      <nav className="mobile-menu">
        <a href="#prestations" onClick={() => handleLinkClick('prestations')}>
          Prestations
        </a>
        <a href="#about" onClick={() => handleLinkClick('about')}>
          A propos
        </a>
        <a href="#contact" onClick={() => handleLinkClick('contact')}>
          Contact
        </a>
      </nav>
      <div className="socials-mobile">
        <a href={contactInfo.instagram}>
          <FontAwesomeIcon className="icon" icon={faInstagram} />
        </a>
        <a href={contactInfo.facebook}>
          <FontAwesomeIcon className="icon" icon={faFacebookF} />
        </a>
        <a href={contactInfo.linkedin}>
          <FontAwesomeIcon className="icon" icon={faLinkedin} />
        </a>
      </div>
    </ReactModal>
  );
};
interface MenuMobileProps {
  isOpen: boolean;
  onClose: () => void;
  scrollToSection: (sectionId: string) => void;
}
